import styled from 'styled-components';

const getProgressColor = (barType) => {
  switch (barType) {
    case 'track':
      return '#00b8b8';
    case 'success':
      return '#7ec666';
    case 'warning':
      return '#fcbd4c';
    case 'danger':
      return '#c55753';
    default:
      return '#00b8b8';
  }
};

export const Progress = styled.div`
  position: 'inherit';
  background-color: ${({ barType }) => getProgressColor(barType)};
  width: ${({ percent }) => `${percent ? percent : 0}%`};
`;

export const ProgressContainer = styled.div.attrs(() => ({ className: 'progress' }))`
  width: 100%;
`;
